import React from "react";
import "./css/Aboutus.css";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
const Aboutus = () => {
  return (
    <div>
      <div className="features">
        <div className="row">
          <div className="img-col">
            <img alt=".." src="Rpic.png" />
          </div>
          <div className="text-col">
            <h2 className="text-col-heading">Radha Kumari</h2>
            <p className="profile-bio">
              Have basic working experience in ML-DL, Cloud computing,
              CI/CD(Jenkins/Github)
            </p>
            <div id="profile-skills">
              <span
                style={{ width: "100%", fontWeight: "700" }}
                id="profile-skills-title"
              >
                Skills:
              </span>
              <span>ML,DL,CLoud,jenkins</span>
            </div>
            <hr />
            <div style={{ width: "100%", left: "10px" }}>
              <center>
                <p style={{ alignItems: "centre" }} id="profile-para">
                  1905101@kiit.ac.in
                </p>
              </center>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <span
                style={{
                  fontWeight: "700",
                  dispaly: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  width: "25%",
                }}
              >
                <center>
                  {" "}
                  <LinkedInIcon
                    style={{ fontSize: "40px", cursor: "-webkit-grab" }}
                    onClick={() => {
                      window.open(
                        "https://www.linkedin.com/in/radha-799a411a6/",
                        "_blank"
                      );
                    }}
                  />
                </center>
              </span>
              <span
                style={{
                  fontWeight: "700",
                  dispaly: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  width: "25%",
                }}
              >
                <center>
                  {" "}
                  <InstagramIcon
                    style={{ fontSize: "40px", cursor: "-webkit-grab" }}
                    onClick={() => {
                      window.open(
                        "https://www.instagram.com/rk.02116/",
                        "_blank"
                      );
                    }}
                  />
                </center>
              </span>
              <span style={{ width: "25%" }}>
                <ContactMailIcon
                  style={{ fontSize: "35px", cursor: "-webkit-grab" }}
                  onClick={() =>
                    (window.location =
                      "mailto:19050101@kiit.ac.in?body=Hello Radha")
                  }
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="features">
        <div className="row">
          <div className="img-col">
            <img alt=".." src="Profile.png" />
          </div>
          <div className="text-col">
            <h2 className="text-col-heading">Yash Mishra</h2>
            <p className="profile-bio">
              I'm currently in my final year, pursuing B.Tech in Computer
              Science at KIIT University. My core interest lies in
              Reactjs,Spring,Selenium.
            </p>
            <div id="profile-skills">
              <span
                style={{ width: "100%", fontWeight: "700" }}
                id="profile-skills-title"
              >
                Skills:
              </span>
              <span>Java,C++,Reactjs,Sql,Spring</span>
            </div>
            <hr />
            <div style={{ width: "100%", left: "10px" }}>
              <center>
                <p style={{ alignItems: "centre" }} id="profile-para">
                  1905073@kiit.ac.in
                </p>
              </center>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <span
                style={{
                  fontWeight: "700",
                  dispaly: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  width: "25%",
                }}
              >
                <center>
                  {" "}
                  <LinkedInIcon
                    style={{ fontSize: "40px", cursor: "-webkit-grab" }}
                    onClick={() => {
                      window.open(
                        "https://www.linkedin.com/in/yash-mishra-1847aa1aa/",
                        "_blank"
                      );
                    }}
                  />
                </center>
              </span>
              <span
                style={{
                  fontWeight: "700",
                  dispaly: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  width: "25%",
                }}
              >
                <center>
                  {" "}
                  <InstagramIcon
                    style={{ fontSize: "40px", cursor: "-webkit-grab" }}
                    onClick={() => {
                      window.open(
                        "https://www.instagram.com/yash____152000/",
                        "_blank"
                      );
                    }}
                  />
                </center>
              </span>
              <span style={{ width: "25%" }}>
                <ContactMailIcon
                  style={{ fontSize: "35px", cursor: "-webkit-grab" }}
                  onClick={() =>
                    (window.location =
                      "mailto:1905073@kiit.ac.in?body=Hello Yash")
                  }
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="features">
        <div className="row">
          <div className="img-col">
            <img alt=".." src="Abhishek.png" />
          </div>
          <div className="text-col">
            <h2 className="text-col-heading">Abhishek Sharma</h2>
            <p className="profile-bio">
              I'm currently in my final year, pursuing B.Tech in Computer
              Science at KIIT University. My core interest lies in Kubernetes
              and docker.
            </p>
            <div id="profile-skills">
              <span
                style={{ width: "100%", fontWeight: "700" }}
                id="profile-skills-title"
              >
                Skills:
              </span>
              <p id="profile-skills-set">Java,C++,Docker,kubernetes</p>
            </div>
            <hr />
            <div style={{ width: "100%", left: "10px" }}>
              <center>
                <p style={{ alignItems: "centre" }} id="profile-para">
                  1905077@kiit.ac.in
                </p>
              </center>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
              }}
            >
              <span
                style={{
                  fontWeight: "700",
                  dispaly: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  width: "25%",
                }}
              >
                <center>
                  {" "}
                  <LinkedInIcon
                    style={{ fontSize: "40px", cursor: "-webkit-grab" }}
                    onClick={() => {
                      window.open(
                        "https://www.linkedin.com/in/abhishek-sharma-406a401a6/",
                        "_blank"
                      );
                    }}
                  />
                </center>
              </span>
              <span
                style={{
                  fontWeight: "700",
                  dispaly: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  width: "25%",
                }}
              >
                <center>
                  {" "}
                  <WhatsAppIcon
                    style={{ fontSize: "40px", cursor: "-webkit-grab" }}
                    onClick={() => {
                      window.open(
                        "https://api.whatsapp.com/send/?phone=%2B917683841205&text&type=phone_number&app_absent=0",
                        "_blank"
                      );
                    }}
                  />
                </center>
              </span>
              <span style={{ width: "25%" }}>
                <ContactMailIcon
                  style={{ fontSize: "35px", cursor: "-webkit-grab" }}
                  onClick={() =>
                    (window.location =
                      "mailto:1905077@kiit.ac.in?body=Hello Abhishek")
                  }
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aboutus;
